module.exports = __webpack_public_path__ + "media/components/assets/images/makeyourdream/blue-b927ddb1f9024a731062f25f877464a9.png";